import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateQuoteProduct as UpdateQuoteProductMutation,
    UpdateQuoteProductVariables,
    QuoteProductsUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_QUOTE_PRODUCT from '../mutations/update-quote-product.graphql';

export const useUpdateQuoteProduct = (): {
    updateQuoteProduct: (input: QuoteProductsUpdateInput) => Promise<any>;
} => {
    const [updateQuoteProduct, {loading, error}] = useMutation<
        UpdateQuoteProductMutation,
        UpdateQuoteProductVariables
    >(UPDATE_QUOTE_PRODUCT);

    return {
        updateQuoteProduct: (input: QuoteProductsUpdateInput) => {
            return updateQuoteProduct({
                variables: {input},
            });
        },

        // @ts-expect-error
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
